import { type ApiConfig, configure } from './apiInstance';
import { getQuestionnaire } from './questionnaire';
import { getRecommendations } from './recommendations';

/**
 * Return selected questions from questionnaire.
 * Under the hood, if the questionnaire is not published, it will retrieve the question from recset table.
 * Otherwise, it will retrieve the question from questionnaire.
 */
export const getSelectedQuestionTexts = async (
  questionnaireId: string,
  config: ApiConfig,
): Promise<string[]> => {
  configure(config);

  const recommendationResult = await getRecommendations(
    questionnaireId,
    config,
  );

  if (!recommendationResult.published) {
    return recommendationResult.questions
      .filter((question) => question.selected)
      .sort((question1, question2) => question1.order - question2.order)
      .map((question) => question.text);
  }

  const questionnaire = await getQuestionnaire(questionnaireId);

  return (
    questionnaire.questions
      ?.filter((question) => question.text)
      .sort(
        (question1, question2) =>
          (question1.order ?? 0) - (question2.order ?? 0),
      )
      // text should always be present
      .map((question) => question.text as string) ?? []
  );
};
